import React, { useState, useEffect } from 'react';
const LanguageDropdown = ({ languages, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(languages[0]);

  useEffect(() => {
    const savedLangCode = sessionStorage.getItem('preferredLang');
    if (savedLangCode) {
      const lang = languages.find((l) => l.code === savedLangCode);
      if (lang) setSelectedLang(lang);
    }
  }, [languages]);

  const handleSelect = (lang) => {
    setSelectedLang(lang);
    sessionStorage.setItem('preferredLang', lang.code);
    onLanguageChange && onLanguageChange(lang.code);
    setIsOpen(false);
  };

  return (
    <div className="relative z-20">
      <div
        className="cursor-pointer px-3 py-1 text-[14px] rounded-[5px] border bg-gray-100 border-gray-300 bg-white flex items-center space-x-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={selectedLang.flag}
          alt={selectedLang.name}
          className="h-[14px] w-auto"
          style={{ display: 'block' }}
        />
        <span>{selectedLang.name}</span>
        <i className="fa-solid fa-chevron-down text-[14px] ml-2"></i>
      </div>
      {isOpen && (
        <ul className="absolute mt-1 bg-white border rounded shadow-md w-full max-h-56 overflow-y-auto">
          {languages.map((lang) => (
            <li
              key={lang.code}
              className="px-3 py-2 hover:bg-[#ACD8D5] text-[14px] flex items-center space-x-2 cursor-pointer"
              onClick={() => handleSelect(lang)}
            >
              <img 
                src={lang.flag} 
                alt={lang.name} 
                className="h-[14px] w-auto"
                style={{ display: 'block' }}
              />
              <span>{lang.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
